import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
// import Avater from "../assits/profile.jpg";
import { BASE_URL, UserContext } from "../contexts/UserContext";
import axios from "axios";
import Loader from "../components/Loader/Loader";
import { followUnFollowUser } from "../utels";

const OtherProfile = () => {
  const { currentUser, setMessage } = useContext(UserContext);
  const { id } = useParams();

  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [isFollow, setIsFollow] = useState();

  useEffect(() => {
    const getUserProfile = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `${BASE_URL}/users/user-details/${id}`
        );
        setUser(data.user);
        setIsFollow(data.user.followers.includes(currentUser._id));
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false);
      }
    };
    getUserProfile();
  }, [id]);
  
const handleUserFollow = async (e) => {
  e.preventDefault();
  try {
    const data = await followUnFollowUser(id);

    setUser(data?.user);

    setIsFollow(
      data?.user?.followers?.some(
        (f) => f?.toString() === currentUser?._id?.toString()
      ) || false
    );

    setMessage(data?.message);
  } catch (error) {
    console.log(error);
  }
};


  //   if(!user) return <Loader/>

  return (
    <section className="profile">
      {loading ? (
        <Loader />
      ) : (
        <div className="container profile__container">
          <Link to={user?._id !== currentUser?._id ? `/posts/users/${user?._id}` : `/myposts/${currentUser?._id}`} className="btn" style={{marginBottom: '1rem'}}>
            {user?._id === currentUser?._id ? "My Posts" : "user posts"}
          </Link>
          <div className="profile__details">
            <div className="user-profile__avater">
              <img src={user?.profile?.secure_url} alt="" />
            </div>
            <div className="right-silde_profile">
              <div className="profile__top">
                <h2>{user.username}</h2>
                {currentUser._id === user._id ? (
                  <Link to={`/profile/${currentUser._id}`} className="btn">Edit Profile</Link>
                ) : (
                  <button className="btn primary" onClick={(e)=> handleUserFollow(e)}>
                    {isFollow ? "following" : "Follow"}
                  </button>
                )}
              </div>
              <div className="profile__post-count">
                <p>{user.postCount?.length} Posts</p>
                <p>{user.followers?.length} followers</p>
                <p>{user.following?.length} following</p>
              </div>
              <div className="profile__name">
                <h3>{user.name}</h3>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default OtherProfile;
